import { render, staticRenderFns } from "./PayPalTransactions.vue?vue&type=template&id=151238a4&scoped=true&"
import script from "./PayPalTransactions.vue?vue&type=script&lang=js&"
export * from "./PayPalTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151238a4",
  null
  
)

export default component.exports